import { API_METHOD, authApiClient } from '../../../api';

export const LOAD_PRODUCT_DETAIL_BANNERS = 'productDetailBanners/LOAD_PRODUCT_DETAIL_BANNERS';
export const UPSERT_PRODUCT_DETAIL_BANNER = 'productDetailBanners/UPSERT_PRODUCT_DETAIL_BANNER';
export const REMOVE_PRODUCT_DETAIL_BANNER = 'productDetailBanners/REMOVE_PRODUCT_DETAIL_BANNER';
export const RESET_PRODUCT_DETAIL_BANNERS = 'productDetailBanners/RESET_PRODUCT_DETAIL_BANNERS';

const initialState = [];
let latestLoadRequestId = 0;

export const loadProductDetailBanners = banners => ({
  type: LOAD_PRODUCT_DETAIL_BANNERS,
  banners,
});

export const resetProductDetailBanners = () => {
  latestLoadRequestId += 1;

  return {
    type: RESET_PRODUCT_DETAIL_BANNERS,
  };
};

export const upsertProductDetailBanner = banner => ({
  type: UPSERT_PRODUCT_DETAIL_BANNER,
  banner,
});

export const removeProductDetailBanner = bannerId => ({
  type: REMOVE_PRODUCT_DETAIL_BANNER,
  bannerId,
});

const notifyFailure = error => {
  alert(error.message);
  return false;
};

export const handleLoadProductDetailBanners = (shouldApply = () => true, { notifyOnError = true } = {}) => {
  return async dispatch => {
    const requestId = ++latestLoadRequestId;

    try {
      const response = await authApiClient(API_METHOD.GET, 'banner/product-detail', undefined);
      if (requestId !== latestLoadRequestId || !shouldApply()) return false;

      dispatch(loadProductDetailBanners(response.data.result));
      return true;
    } catch (error) {
      if (requestId !== latestLoadRequestId || !shouldApply()) return false;

      return notifyOnError ? notifyFailure(error) : false;
    }
  };
};

export const handleReorderProductDetailBanners = (ids, onSuccess, shouldApply = () => true) => {
  return async dispatch => {
    try {
      const response = await authApiClient(API_METHOD.PATCH, 'banner/product-detail/order', { ids });
      if (!shouldApply()) return true;

      dispatch(loadProductDetailBanners(response.data.result));
      await dispatch(handleLoadProductDetailBanners(shouldApply, { notifyOnError: false }));
      if (!shouldApply()) return true;

      if (onSuccess) onSuccess(response.data.result);
      return true;
    } catch (error) {
      if (!shouldApply()) return false;

      return notifyFailure(error);
    }
  };
};

export default function productDetailBanners(state = initialState, action) {
  switch (action.type) {
    case LOAD_PRODUCT_DETAIL_BANNERS:
      return action.banners;
    case UPSERT_PRODUCT_DETAIL_BANNER:
      return [...state.filter(banner => banner.id !== action.banner.id), action.banner].sort(
        (first, second) => first.order_no - second.order_no
      );
    case REMOVE_PRODUCT_DETAIL_BANNER:
      return state
        .filter(banner => banner.id !== action.bannerId)
        .sort((first, second) => first.order_no - second.order_no)
        .map((banner, index) => ({ ...banner, order_no: index + 1 }));
    case RESET_PRODUCT_DETAIL_BANNERS:
      return initialState;
    default:
      return state;
  }
}
